<template>
  <div class="agreement">
    <div style="text-align: right;">更新日期：2025年02月22日</div>
    <div style="text-align: right;">生效日期：2025年02月22日</div>
<p>欢迎使用橙鹿提供的产品和服务。我们非常重视对您的个人隐私和个人信息安全保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。有时候我们需要某些信息才能为您提供您请求的服务，我们希望通过本《隐私政策》向您说明我们在收集和使用您相关个人信息时对应的处理规则。本隐私政策声明适用于橙鹿提供的所有服务，当您使用我们任何单项服务时，视为您同意接受本《隐私政策》。<br>
【特别提示】请您在使用橙鹿服务前，仔细阅读（未成年人请在监护人陪同下阅读）并了解本《隐私政策》（特别是字体加粗部分的内容），以做出适当选择。一旦您使用或在我们更新本《隐私政策》后继续使用我们的产品或服务，即意味着您同意本《隐私政策》并同意我们按照本《隐私政策》收集、使用、储存、分享、转让和披露您的相关个人信息。<br>
一、我们如何收集您的个人信息<br>
个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。此类信息会在您注册和使用我们的服务时被收集，橙鹿根据合法、正当、必要原则，仅会出于本政策所述以下目的收集和使用您的个人信息。<br>
1.我们收集的个人信息<br>
（1）注册信息：您使用橙鹿提供的服务，可以注册并登录您个人专属账号。此时，您需要向我们提供以下信息：<strong>账号名称、头像（如有）和手机号码、电子邮箱</strong>等。提供上述信息并同意注册协议和本政策后，您可以使用本平台的业务功能，包括：<strong>浏览平台内的学历产品/服务、提问、回答、评论、评价</strong>等。如您拒绝提供手机号码或进行实名验证，可能会影响本平台功能的访问和使用。<br>
（2）您在平台作出的评价和发布的内容：您在橙鹿平台上主动对产品和服务进行评价或发布其他内容（发表评论）时，平台将收集您发布的信息，并<strong>展示您的昵称、头像和发布内容</strong>。如您选择以匿名方式发布评价信息时，平台将不展示您的昵称、头像。您还可以通过<strong>主动上传图片、视频方式授权访问您的相机、照片和麦克风，以便于您通过拍照、拍视频、上传照片或上传视频方式发布内容</strong>。<br>
（3）客服及咨询服务相关的通信记录信息：当您与橙鹿平台的客服或咨询师取得联系时，平台的系统可能会记录您与上述人员之间的通讯记录，以及使用您的账号信息以便核验身份。<br>
（4）用户共享的信息：当您在橙鹿平台中使用第三方提供的服务时，您同意本平台允许该第三方收集您的账号名称、头像及其他提供服务所必需的个人信息。如果您拒绝第三方在提供服务时收集上述信息，将可能导致您无法在本平台中使用该第三方服务。<br>
（5）通过第三方获取您个人信息：为了更好地服务，我们的平台会集成一些第三方服务（如下）从而产生对应的信息收集处理。<br>
（5.1）微信SDK<br>
第三方主体：深圳市腾讯计算机系统有限公司<br>
使用目的：<strong>帮助用户分享内容至微信客户端， 跳转打开微信小程序 数据类型：设备标识信息（MAC/Android ID/IMEI/IMSI/硬件序列号/OAID（Android端）/IDFA（iOS14.5之前））、IP地址、存储权限 、剪切板权限、设备加速器（如重力感应设备）</strong><br>
处理方式：<strong>去标识化和加密处理</strong><br>
隐私政策链接：<a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">微信Open SDK个人信息处理规则</a><br>
（5.2）DCloud uni-app(（5+App/Wap2App)<br>
使用目的：<strong>提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务</strong><br>
使用权限：<strong>存储的个人文件，设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）</strong><br>
隐私政策链接：<a href="https://ask.dcloud.net.cn/protocol.html">用户服务条款</a><br>
（5.3）高德开放平台权限要求及隐私政策<br>
高德开放平台: com.amap.api, com.loc, com.autonavi<br>
使用目的: <strong>实现定位/展现地图</strong><br>
权限要求:粗<strong>略定位权限、精准定位权限、访问网络状态权限、访问WiFi状态权限、改变WiFi状态权限、读取手机状态权限、写入外部存储权限, Sim卡序列号</strong><br>
涉及信息:<strong>存储的个人文件、位置信息、读取手机状态和身份、网络信息、传感器信息、Android ID, Sim卡序列号</strong><br>
隐私政策链接: <a href="https://lbs.amap.com/pages/privacy/">高德地图开放平台隐私权政策 | 高德地图API</a><br>
（5.4）融合SDK（Gromore）<br>
第三方主体：北京巨量引擎网络技术有限公司<br>
使用目的：<strong>提供帮助调整广告变现策略及数据分析的服务</strong><br>
<strong>使用权限：设备品牌、型号、操作系统及api版本信息、系统时区、系统语言、屏幕密度、屏幕分辨率、CPU信息、IDFV、应用包名、版本号、IP 地址、运营商信息、WiFi状态、移动国家码、系统国家/区域信息、精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID，BSSID））、用户操作/行为日志信息、网络接入方式、类型、状态、网络质量数据</strong><br>
处理方式：<strong>去标识化和加密处理</strong><br>
隐私政策链接：<a href="https://www.csjplatform.com/terms/gromoresdk-privacy">融合SDK隐私政策 - 穿山甲广告平台</a><br>
（5.5）MSA移动安全联盟SDK<br>
第三方主体：中国信息通信研究院<br>
使用目的：<strong>用于广告投放，统计安装归因</strong><br>
数据类型：<strong>设备标识信息（OAID）</strong><br>
处理方式：<strong>去标识化和加密处理</strong><br>
隐私政策链接：<a href="http://www.msa-alliance.cn/col.jsp?id=122">移动安全工作委员会</a><br>
（5.6）AppsFlyer SDK<br>
第三方主体：AppsFlyer Inc.<br>
使用目的：<strong>营销相关服务</strong><br>
使用权限：<strong>设备标识符（Android如Android ID、OAID，iOS如IDFV）、安装引荐来源网址和应用程序 ID（行为主体为APP，数据不会共享给AppsFlyer）</strong><br>
处理方式：<strong>去标识化和加密处理</strong><br>
隐私政策链接：<a href="https://www.appsflyer.com/legal/privacy-policy/">https://www.appsflyer.com/legal/privacy-policy/</a><br>
（5.7）第三方SDK名称：个推<br>
使用目的：<strong>消息推送服务</strong><br>
推送服务收集个人信息类型：<strong>存储的个人文件、设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI、获取GAID信息）、应用已安装列表、网络信息调用的设备权限：获取网络状态、访问Wi-Fi状态、读取手机状态和身份</strong><br>
SDK隐私政策链接： <a href="https://docs.getui.com/privacy/">https://docs.getui.com/privacy/</a><br>
日后，橙鹿平台还可能引入其他第三方合作平台，您将来可以使用微信登录橙鹿；同时，您也可能将您的个人微信和用户账号绑定在一起，以方便接收到相关产品的最新进展。您可选择授权橙鹿在符合相关法律法规规定的前提下读取您在该第三方平台上登记、公布、记录的公开信息（包括但不限于昵称、头像、关注用户列表等）。如果您拒绝提供上述信息，可能会影响本平台功能的访问和应用。<br>
（5.8）广点通转化Android SDK<br>
SDK名称：广点通转化Android SDK<br>
包名：com.qq.gdt.action<br>
开发者：深圳市腾讯计算机系统有限公司<br>
功能：<strong>转化SDK 是由腾讯公司开发，单独或包含在 SDK 中集成到应用软件，为开发者及其用户提供广告投放效果追踪，基础运算统计效果等服务的 SDK。</strong><br>
收集个人信息类型：<strong>设备信息、应用信息、营销信息、位置信息、性能数据、其他信息</strong><br>
收集方式：<strong>SDK 集成后，用户使用转化SDK及相关服务的过程中，我们将根据合法、正当、必要的原则收集信息</strong><br>
处理方式：<strong>我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您和/或最终用户的个人信息，并使用安全保护机制防止您和/或最终用户的个人信息遭到恶意攻击。</strong><br>
SDK隐私政策链接：<br>
<a href="https://datanexus.qq.com/doc/develop/compliance/android/privacy_policy">广点通转化 SDK 个人信息保护规则</a><br>
（5.9）百度oCPX转化追踪SDK<br>
SDK名称：百度oCPX转化追踪SDK<br>
包名：com.baidu.mobads<br>
开发者：北京百度网讯科技有限公司<br>
功能：<strong>提供广告主监控其广告转化的功能</strong><br>
收集个人信息类型：<strong>设备信息、应用信息、营销信息、位置信息、性能数据、其他信息</strong><br>
收集方式：<strong>SDK 集成后，用户使用转化SDK及相关服务的过程中，我们将根据合法、正当、必要的原则收集信息</strong><br>
处理方式：<strong>我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您和/或最终用户的个人信息，并使用安全保护机制防止您和/或最终用户的个人信息遭到恶意攻击。</strong><br>
SDK隐私政策链接：<br>
<a href="https://ocpx-devcenter.bj.bcebos.com/%E5%BA%94%E7%94%A8SDK%E8%B5%84%E6%BA%90/%E3%80%90%E7%99%BE%E5%BA%A6oCPX%E8%BD%AC%E5%8C%96%E8%BF%BD%E8%B8%AASDK%E3%80%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96%2020250303.pdf?authorization=bce-auth-v1/e2ea496b5e7f4e20bd0e5d1ce5533588/2025-03-03T03%3A24%3A50Z/-1/host/f51f435fb61f7078188b3f185fcbffa4f08b54840da573f0050f6c90ce7dcb70">百度自研SDK隐私政策</a><br>

（6）间接收集到您的个人信息：为向您展示和推送商品或服务，基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息（包括您的浏览及搜索记录、设备信息、位置信息、手机号码、您参与橙鹿线上或线下活动填写问卷调查上的个人信息），我们可能会基于上述一项或几项信息的结合，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐内容。<br>

2.征得授权同意的例外<br>
根据相关法律法规规定及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无须征得您的同意：<br>
（1）与个人信息控制者履行法律法规规定的义务相关的；<br>
（2）与国家安全、国防安全直接相关的；<br>
（3）与公共安全、公共卫生、重大公共利益直接相关的；<br>
（4）与刑事侦查、起诉、审判和判决执行等直接相关的；<br>
（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；<br>
（6）所涉及的个人信息是个人信息主体自行向社会公众公开的；<br>
（7）根据个人信息主体要求签订和履行合同所必需的；<br>
（8）从合法公开披露的信息中收集个人信息的，例如合法的新闻报道、政府信息公开等渠道；<br>
（9）维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。<br>
二、我们使用您的个人信息的目的<br>
我们严格遵守法律法规及隐私政策之约定，将收集的信息用于以下途径。若我们超出以下范畴，我们将会再次向您说明并取得您的同意：<br>
1.为您提供服务。<br>
2.帮助我们设计新服务，提升现有服务体验。<br>
3.在我们提供服务时，用于身份验证、客户服务、咨询服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。<br>
4.向您发送适合您的产品和服务的信息；向您提供与您更加相关的广告以替代普遍投放的广告；邀请您参与橙鹿市场调查。<br>
5.开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。<br>
三、我们关于使用个人信息权限的方式、范围<br>
您理解并同意，橙鹿平台可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及个人信息的收集和使用：<br>
（1）如我们访问您的位置信息，是为了根据您的位置信息为您提供更契合您需求的页面展示和产品服务，并用于展示用户当前地区相关资讯，以及当地的备考机构和提升专业院校方案的推荐；<br>
（2）如我们访问您的摄像头，是为了使您可以使用摄像头进行扫码、拍摄，用于实现登录、图片评论、拍照取词、咨询客服、观看视频等功能；<br>
（3）如我们读取您的电话状态，是为了读取设备通话状态和识别码，识别手机设备ID，用于完成音视频、信息展示、账号登录（防止过多设备登录同一个账号）、安全保障等主要功能；<br>
（4）如我们访问您的相册读取外置存储器，是为了使您可以实现您设备中的照片、图片或视频的取用与上传，便于您进行更换头像、发表评论或进行分享；<br>
（5）如我们写入外置存储器，是为了APP允许写入/下载/保存/修改/删除图片、文件等信息，并用于下载课件使用；<br>
（6）如我们访问您的麦克风，是为了使您可以实现与客服或咨询师实现语音交互以及语音教学交互功能，在这些功能中我们会收集您的录音内容以识别您的具体需求；<br>
当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的个人信息收集及使用。<br>
四、我们会如何共享、转让、公开披露您的个人信息<br>
1.共享<br>
橙鹿不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是经您确认同意，本平台可在以下情况下共享您的个人信息：<br>
（1）在获取同意的情况下共享：获得您的明确同意后，本平台会与其他方共享您的个人信息。<br>
（2）共享给关联公司：橙鹿为橙鹿教育科技（湖北）有限公司开发运营并持有，在本政策声明的使<br>
用目的范围内，您的个人信息可能会与前述公司的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。<br>
（3）共享给授权合作伙伴：橙鹿可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验，我们的合作伙伴包括以下类型：<br>
a.入驻机构及合作高等院校。仅为实现本政策中声明的目的，我们的某些服务将由业务合作伙伴提供。以保障为您提供的服务顺利完成，我们可能会将您的个人信息共享给上述合作伙伴。其中可能包括您的联络信息，以保障为您提供的服务顺利完成。<br>
b.其他业务合作伙伴。我们还可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们仅会向这些合作伙伴提供推广的覆盖面、有效性以及统计类等信息，而不会提供可以识别您身份的个人信息。<br>
（4）在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。<br>
2.转让<br>
橙鹿不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br>
（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>
（2）随着本平台业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您个人信息的公司、组织继续受本《隐私政策》的约束，否则，我们将要求该公司、组织重新向您征求授权同意。<br>
3.公开披露<br>
我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：<br>
（1）获得您的明确同意；<br>
（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求。但我们保证，在符合法律法规的前提<br>
下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件。<br>
（3）根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。<br>
五、我们如何管理您的个人信息<br>
1.橙鹿将尽一切可能采取合法适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。您可以通过在橙鹿APP/小程序中的“我的”页面，点击用户头像，对您现有的注册及其他已提供的信息进行查看、更正。<br>
<strong>2.个人信息主体注销账户</strong><br>
<strong>您随时可注销此前注册的账户（注销路径：我的-设置-账号注销），注销客服电话：15071250382，我们将在15个工作日内处理您的注销请求。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</strong><br>
<strong>在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。</strong><br>
3.响应您的上述请求<br>
为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求，我们将在三十天内做出答复。<br>
对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份上存放的信息）的请求，我们可能会予以拒绝。<br>
在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br>
1、与国家安全、国防安全有关的；<br>
2、与公共安全、公共卫生、重大公共利益有关的；<br>
3、与犯罪侦查、起诉和审判等有关的；<br>
4、有充分证据表明您存在主观恶意或滥用权利的；<br>
5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。<br>
六、我们如何保护和保存您的个人信息<br>
1.橙鹿会采取各种预防措施来保护您的个人信息，以保障您的个人信息免遭丢失、盗用和误用，以及被擅自取阅、披露、更改或销毁。为确保您个人信息的安全，平台有严格的信息安全规定和流程，并有专门的信息安全团队在公司内部严格执行上述措施。<br>
2.橙鹿会采取一切合理可行的措施，确保未收集与本平台提供的服务无关的个人信息。但请您知悉并理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。但您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码个人信息透露给他人。<br>
3.在发生个人信息安全事件的场合，本平台将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。<br>
4.同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<br>
我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。<br>
七、关于免责说明<br>
就下列相关事宜的发生，橙鹿不承担任何法律责任：<br>
1.由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄漏，或其他非因本平台原因导致的个人信息的泄漏；<br>
2.本平台根据法律规定或政府相关政策要求提供您的个人信息；<br>
3.任何第三方根据与本平台各服务条款及声明中所列明的情况使用您的个人信息，由此所产生的纠纷；<br>
4.任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性网站关闭；<br>
5.因不可抗力导致的任何后果；<br>
6.本平台在各服务条款及声明中列明的使用方式或免责情形。<br>
7.开发者联系方式邮箱：<a href="mailto:chenglu@orgdeeredu.com">chenglu@orgdeeredu.com</a><br>
八、本政策适用范围<br>
若您不同意修改后的隐私政策，您有权并应立即停止使用橙鹿的服务。如果您继续使用本平台的服务，则视为您接受我们对本政策相关条款所做的修改。<br>
本平台的所有服务特别是用户增值服务均适用本政策。<br>
九、争议解决和法律适用<br>
1.如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，争议各方一致同意将发生的争议提交至本协议签订地湖北省武汉市东湖新技术开发区有管辖权的法院进行第一审管辖。<br>
2.本协议条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本协议条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。<br>
3.【其他】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。<br></p>

<div style="text-align: right;">更新日期：2025年02月22日</div>
    <div style="text-align: right;">生效日期：2025年02月22日</div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data() {
    return {};
  },
  mounted() {
    this.changeTitle();
  },
  methods: {
    changeTitle() {
      document.title = '橙鹿隐私政策';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  height: 100%;
  background: #fff;
  font-size: 26px;
  color: #06112a;
  padding: 20px 20px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  line-height: 36px;
  padding: 30px 0 14px;
}

p {
  padding: 20px 32px;
  line-height: 42px;
}

.agreement-p {
  padding: 0 32px;
}

.agreement-p p {
  line-height: 42px;
  text-align: justify;
}

.p2 {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/agreement.vue